// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host {
  display: block;
  height: 100%;
}
:host .error-message {
  color: #ff4c4c;
}
:host .lead-func-header {
  background-color: #f5f8fa;
  border-bottom: 1px solid #dfe3eb;
  display: flex;
  padding: 0 1rem;
  flex-direction: column;
  margin: -1rem -1rem 0;
}
:host .lead-func-header cs-icon {
  width: 15px;
  height: 15px;
}
:host .lead-func-header .actions .xs-arrow {
  min-width: 15px;
  padding: 8px;
  margin-left: 2px;
  border-radius: 0;
}
:host .lead-func-header .actions .xs-arrow:hover {
  opacity: 0.8;
}
:host .lead-func-header .actions ul {
  padding-left: 0;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);
}
:host .lead-func-header .actions ul.min-250 {
  min-width: 250px;
}
:host .lead-func-header .actions ul li {
  list-style-type: none;
  padding-bottom: 10px;
  cursor: pointer;
}
:host .lead-func-header .audio-call {
  height: 35px;
}
:host .lead-func-header .lead-details {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  color: #4b5b70;
}
:host .lead-func-header .lead-details span:first-child {
  font-family: Roboto-Medium;
}
:host .lead-func-header .lead-save {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
:host .lead-func-header .lead-save p {
  min-width: auto;
  font-size: 12px;
}
:host .lead-func-header .lead-save .lead-space {
  line-height: 14px;
  padding-right: 12px;
}
:host .lead-func-header .lead-save .lead-space span {
  color: #4b5b70;
  font-family: Roboto-Medium;
}
:host .lead-func-header p {
  margin: 0;
  min-width: 230px;
}
:host .lead-func-header .line-1 {
  display: flex;
}
:host .lead-func-header .line-2 {
  display: flex;
}
:host .lead-func-header .line-3 {
  display: flex;
}
:host .lead-func-header .w125 {
  width: 125px;
}
:host .call-status-icon {
  width: 17px;
  height: 17px;
}
:host .lead-func-states {
  display: flex;
  padding-top: 0.6rem;
}
:host .lead-func-states cs-select {
  min-width: 140px;
  margin-right: 5px;
}
:host .cs-virtual-tabs-container {
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid #dfe3eb;
  position: relative;
}
:host .cs-virtual-tabs-container .cs-virtual-tabs {
  display: flex;
  height: 42px;
  position: absolute;
  bottom: 100%;
  right: 0;
}
:host .cs-virtual-tabs-container .cs-virtual-tabs .cs-virtual-tab {
  padding: 0.5rem 0.8rem;
  font-size: 12px;
  line-height: 1rem;
  font-family: Roboto-Medium;
  color: #4b505a;
  border: 1px solid transparent;
  transition: all 100ms ease-in-out;
  outline: 0;
  background-color: #f5f8fa;
}
:host .cs-virtual-tabs-container .cs-virtual-tabs .cs-virtual-tab.cs-virtual-tab-active {
  border-top: 1px solid #dfe3eb;
  border-left: 1px solid #dfe3eb;
  border-right: 1px solid #dfe3eb;
  background-color: #fff;
  margin-bottom: -1px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
:host .cs-virtual-tabs-container .cs-virtual-tabs .cs-virtual-tab:focus {
  outline: 0;
}
:host .mw170 {
  max-width: 170px;
}
:host .min-w230 {
  min-width: 230px;
}
:host .whitespace-nowrap {
  white-space: nowrap;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
